import moment from "moment";
import Vue from "vue";
moment.locale("pt-br");

Vue.filter("dataFormatada", function(value) {
	if (value) {
		return moment(value).format("L");
	}
});
Vue.filter("dataHoraFormatada", function(value) {
	if (value) {
		return moment(value).format("lll");
	}
});
Vue.filter("uppercase", function(value) {
	if (value) {
		return value.toUpperCase();
	}
});
Vue.filter("numberFormat", function (number, decimals, decPoint, thousandsSep) {
	if (!number) {
		return '';
	}
	number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	var n = !isFinite(+number) ? 0 : +number;
	var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
	var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
	var s = '';
	var toFixedFix = function (n, prec) {
		var k = Math.pow(10, prec);
		return '' + Math.round(n * k) / k;
	};

	s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '').length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1).join('0');
	}
	return 'R$ ' + s.join(dec);
});

Vue.filter("inteiro", function(value) {
		let valor = "";
		if (value != null) {
			valor = parseInt(value);
		}
		return valor;
});

Vue.filter("nivel", function(value) {
	switch (value) {
		case '1':
			return 'Usuário';
		case '2':
			return 'Administrador';
		case '3':
			return 'Franqueado';
	}
});



// WEBPACK FOOTER //
// ./src/filters/index.js